import script from "./ManagerFlows.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagerFlows.vue?vue&type=script&setup=true&lang=js"

import "./ManagerFlows.vue?vue&type=style&index=0&id=36e983d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36e983d8"]])

export default __exports__